import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function AnimatedGradientBackground({
  children,
  className = ''
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start start', 'end start']
  });
  // Parallax transforms for background orbs (slow movement)
  const orbY1 = useTransform(scrollYProgress, [0, 1], [0, 150]);
  const orbY2 = useTransform(scrollYProgress, [0, 1], [0, 100]);
  const orbY3 = useTransform(scrollYProgress, [0, 1], [0, 80]);
  const orbY4 = useTransform(scrollYProgress, [0, 1], [0, 120]);
  return <div ref={containerRef} className={`relative w-full overflow-hidden bg-deep-blue ${className}`} data-id="element-1078">
      {/* CSS Animations */}
      <style data-id="element-1079">{`
        @keyframes float-slow {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(20px, -20px); }
        }
        @keyframes float-medium {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(-15px, 15px); }
        }
        @keyframes float-fast {
          0%, 100% { transform: translate(0, 0); }
          50% { transform: translate(10px, 10px); }
        }
        @keyframes pulse-glow {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.1); }
        }
        @keyframes rotate-slow {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      {/* Background Layers */}
      <div className="absolute inset-0 z-0" data-id="element-1080">
        {/* Base Gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-deep-blue via-[#1a426b] to-deep-blue opacity-90" data-id="element-1081" />

        {/* Animated Orbs/Blobs with Parallax */}
        {/* Top Left - Mint Glow */}
        <motion.div className="absolute -top-[20%] -left-[10%] w-[600px] h-[600px] rounded-full bg-mint/10 blur-[100px]" style={{
        y: orbY1
      }} data-id="element-1082" />

        {/* Bottom Right - Deep Blue/Purple Accent */}
        <motion.div className="absolute top-[40%] -right-[10%] w-[500px] h-[500px] rounded-full bg-[#4c1d95]/20 blur-[120px]" style={{
        y: orbY2
      }} data-id="element-1083" />

        {/* Center - Subtle Highlight */}
        <motion.div className="absolute top-[20%] left-[30%] w-[400px] h-[400px] rounded-full bg-white/5 blur-[80px]" style={{
        y: orbY3
      }} data-id="element-1084" />

        {/* Bottom Left - Secondary Mint */}
        <motion.div className="absolute -bottom-[10%] left-[10%] w-[300px] h-[300px] rounded-full bg-mint/5 blur-[60px]" style={{
        y: orbY4
      }} data-id="element-1085" />

        {/* Grid Pattern Overlay */}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} data-id="element-1086" />
      </div>

      {/* Content */}
      <div className="relative z-10" data-id="element-1087">{children}</div>
    </div>;
}